import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCopyLocalPpis } from '../actions';
import { getCopyLocalPpis, getIsCopyLocalFetching } from '../selectors';

const useCopyLocalPpis = (withStatus, secondStatus) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsCopyLocalFetching);
  const copyLocalPpis = useSelector(getCopyLocalPpis);

  useEffect(() => {
    dispatch(fetchCopyLocalPpis());
  }, [dispatch]);

  return [isFetching, copyLocalPpis];
};

export default useCopyLocalPpis;
